// import { useParams, useNavigate, Link } from 'react-router-dom';
// import { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import OrganisationView from './OrganisationView';
// import SelectedContact from '../../contact/SelectedContact';
// import Clientlist from './Clientlist';
// import { useAuth } from '../../../context/AuthContext';
// import withPermission from '../../../utils/withPermission';
// import { Container, Card, Tabs, Tab, Button } from 'react-bootstrap';
// import { BiPencil } from "react-icons/bi";
// import { BsChevronLeft } from "react-icons/bs";
// import OrganisationModal from './OrganisationModal';
// const OrganisationDetails = () => {
//     const { id } = useParams();
//     const navigate = useNavigate();
//     const [organisationDetails, setOrganisationDetails] = useState(null);
//     const [activeTab, setActiveTab] = useState('transactionList');
//     const didFetchRef = useRef(false);
//     const [organisations, setOrganisation] = useState(null);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedOrganisation, setSelectedOrganisation] = useState(null);
//     const [industries, setIndustries] = useState([]);
//     const WithContactPermission = withPermission(({ children }) => children, ['contact-list']);

//     useEffect(() => {
//         if (!didFetchRef.current) {
//             fetchOrganisationDetails();
//             didFetchRef.current = true;
//         }
//     }, [id]);

//     const fetchOrganisationDetails = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;
//             const response = await axios.get(`${backendUrl}/api/organisation/${id}`, {
//                 headers: { 'Authorization': `Bearer ${token}`,
//                 'Tenant-Origin': origin,
//             },
//             });
//             setOrganisationDetails(response.data.data);
//         } catch (error) {
//             console.error('Error fetching organisation details:', error);
//         }
//     };
//     const editOrganisation = async (contactId, updatedData) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             const response = await axios.put(`${backendUrl}/api/organisation/${contactId}`, updatedData, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             const updatedOrganisation = response.data.Data;

//             if (updatedOrganisation) {
//                 // ✅ Update organisation details state
//                 setOrganisationDetails(updatedOrganisation);

//                 // ✅ Update the organisations list state if needed
//                 setOrganisation((prevOrganisations) =>
//                     prevOrganisations
//                         ? prevOrganisations.map((org) =>
//                             org.id === updatedOrganisation.id ? updatedOrganisation : org
//                         )
//                         : [updatedOrganisation] // If null, set it as an array
//                 );
//             } else {
//                 console.error('Update failed, no data returned.');
//             }
//             setShowModal(false);
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 return error.response.data.errors; // Return validation errors
//             } else {
//                 console.error(`Error updating`, error);
//             }
//         }
//     };


//     const fetchIndustries = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             let allIndustries = [];
//             let currentPage = 1;
//             let lastPage = 1;


//             const response = await axios.get(`${backendUrl}/api/industries`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,

//             });

//             allIndustries = [...allIndustries, ...response.data.industry]


//             setIndustries(allIndustries);
//         } catch (error) {
//             console.error('Error fetching industries:', error);
//         }
//     };
//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                                 {/* 🔹 Back Button & Title */}
//                                 <h4 className="mb-sm-0 d-flex align-items-center">
//                                     <BsChevronLeft
//                                        className='back-button1'
//                                         onClick={() => navigate(-1)}
//                                     />
//                                     <span>ORGANISATIONS</span>
//                                 </h4>

//                             </div>
//                         </div>
//                     </div>

//                     <div className="p-6 max-w-7xl mx-auto">
//                         {/* Organisation Info Card */}
//                         {/* {organisationDetails && ( */}
//                         <>
//                             {/* Internal Styles */}


//                             <Card className="mb-4 shadow-lg rounded-3 p-2 border-0 card-bg">
//                                 {/* Header Section with Name and Edit Icon */}
//                                 <div className="d-flex justify-content-between align-items-center">
//                                     <Card.Title className="fw-bold font-size-14 text-primary">{organisationDetails?.name}</Card.Title>
//                                     <BiPencil
//                                         className="text-primary hover-effect2 edit-pencil"
//                                         onClick={() => {
//                                             setSelectedOrganisation(organisationDetails); // Store organisation details
//                                             setShowModal(true); // Open modal
//                                         }} />
//                                 </div>
//                                 <Card.Body className="pt-3">
//                                     <div className="row">
//                                         {/* Left Section */}
//                                         <div className="col-md-6">
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block card-label"><strong>Type:</strong></span>
//                                                 <span className="text-muted card-value">{organisationDetails?.org_type || '-'}</span>
//                                             </div>
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block card-label"><strong>Sector:</strong></span>
//                                                 <span className="text-muted card-value">{organisationDetails?.industry?.name || '-'}</span>
//                                             </div>
//                                         </div>

//                                         {/* Right Section */}
//                                         <div className="col-md-4">
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block card-label"><strong>Website:</strong></span>
//                                                 <span className="fw-semibold text-primary card-value">{organisationDetails?.website || ''}</span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </Card.Body>
//                             </Card>
//                             {showModal && (
//                                 <OrganisationModal
//                                     showModal={showModal}
//                                     handleClose={() => setShowModal(false)}
//                                     orgData={selectedOrganisation} // Pass data here
//                                     editOrg={editOrganisation}
//                                     fetchIndustries={fetchIndustries}
//                                     orgId={id}
//                                     industries={industries}
//                                 />
//                             )}

//                         </>


//                         {/* )} */}
//                         <div className="row">
//                             <div className="col-xl-12 col-lg-8">
//                                 <div className="card">
//                                     {/* Nav tabs */}
//                                     <ul className="nav nav-tabs nav-tabs-custom justify-content-start pt-2 font-size-13" role="tablist">
//                                         <WithContactPermission>
//                                         <li className="nav-item">
//                                             <a
//                                                 className={`nav-link ${activeTab === 'transactionList' ? 'active' : ''}`}
//                                                 onClick={() => setActiveTab('transactionList')}
//                                                 role="tab"
//                                             >
//                                                 Contact List
//                                             </a>
//                                         </li>
//                                         </WithContactPermission>
//                                         <li className="nav-item">
//                                             <a
//                                                 className={`nav-link ${activeTab === 'organisationDetails' ? 'active' : ''}`}
//                                                 onClick={() => setActiveTab('organisationDetails')}
//                                                 role="tab"
//                                             >
//                                                 Organisation Details
//                                             </a>
//                                         </li>
//                                     </ul>


//                                     {/* Tab panes */}
//                                     <div className="tab-content p-4">
//                                         {/* Contact List Tab */}
//                                         {activeTab === "transactionList" && (
//                                             <div className="tab-pane active" id="contact-list" role="tabpanel">
//                                                 <div className="p-3">
//                                                     <SelectedContact
//                                                         organisationId={organisationDetails?.id}
//                                                         entityType="org"
//                                                         fetchOrganisationData={fetchOrganisationDetails}
//                                                         organisationData={organisationDetails}
//                                                         setOrganisationDetails={setOrganisationDetails}
//                                                     />
//                                                 </div>
//                                             </div>
//                                         )}

//                                         {/* Organisation Details Tab */}
//                                         {activeTab === "organisationDetails" && (
//                                             <div className="tab-pane active" id="organisation-details" role="tabpanel">
//                                                 <div>
//                                                     {organisationDetails ? (
//                                                         <OrganisationView
//                                                             data={organisationDetails}
//                                                             type="org"
//                                                             organisationId={id}
//                                                             setOrganisationDetails={setOrganisationDetails}
//                                                         />
//                                                     ) : (
//                                                         <p>Loading...</p>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>

//                                 </div>
//                             </div>

//                         </div>



//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };
// export default OrganisationDetails;

import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import OrganisationView from './OrganisationView';
import SelectedContact from '../../contact/SelectedContact';
import { useAuth } from '../../../context/AuthContext';
import withPermission from '../../../utils/withPermission';
import { Container, Card, Tabs, Tab, Button, Offcanvas, Badge, Row, Col } from 'react-bootstrap';
import { BiPencil, BiLinkExternal } from "react-icons/bi";
import { BsChevronLeft, BsX, BsBuilding, BsPeople, BsGlobe, BsGeoAlt, BsTelephone, BsEnvelope } from "react-icons/bs";
import { FaIndustry, FaUserTie, FaIdCard, FaMapMarkerAlt } from "react-icons/fa";
import { MdBusiness, MdWork } from "react-icons/md";
import OrganisationModal from './OrganisationModal';
import { useParams, useNavigate, Link } from 'react-router-dom';
import Swal from 'sweetalert2';

const OrganisationDetails = ({ showOffcanvas: initialShowOffcanvas, handleClose, organisationId, onOrganisationUpdate, orgs }) => {
    const navigate = useNavigate();
    const [organisationDetails, setOrganisationDetails] = useState(null);
    const [activeTab, setActiveTab] = useState('contactList');
    const didFetchRef = useRef(false);
    const [organisations, setOrganisation] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedOrganisation, setSelectedOrganisation] = useState(null);
    const [industries, setIndustries] = useState([]);
    const WithContactPermission = withPermission(({ children }) => children, ['contact-list']);
    const [isTemporarilyHidden, setIsTemporarilyHidden] = useState(false);
    const [showContactModal, setShowContactModal] = useState(false);
    const [showOffcanvas, setShowOffcanvas] = useState(initialShowOffcanvas);
    useEffect(() => {
        setShowOffcanvas(initialShowOffcanvas);
    }, [initialShowOffcanvas]);
    useEffect(() => {
    if (showOffcanvas) {
        setShowContactModal(false);
    }
}, [showOffcanvas]);
    useEffect(() => {
        if (showOffcanvas && organisationId && !didFetchRef.current) {
            fetchOrganisationDetails();
            didFetchRef.current = true;
        }
    }, [organisationId, showOffcanvas]);

    const fetchOrganisationDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;
            const response = await axios.get(`${backendUrl}/api/organisation/${organisationId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            setOrganisationDetails(response.data.data);
        } catch (error) {
            console.error('Error fetching organisation details:', error);
        }
    };
    const handleReopenOffcanvas = () => {
        // Reopen after a small delay for smoother transition
        setTimeout(() => {
            fetchOrganisationDetails();
        }, 300);
    };

    const editOrganisation = async (contactId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const response = await axios.put(`${backendUrl}/api/organisation/${contactId}`, updatedData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const updatedOrganisation = response.data.Data;

            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                },
            });

            if (updatedOrganisation) {
                setOrganisationDetails(updatedOrganisation);
                if (onOrganisationUpdate) {
                    onOrganisationUpdate();
                }
                Toast.fire({
                    icon: "success",
                    title: "Organisation updated successfully!",
                });
            } else {
                console.error('Update failed, no data returned.');
            }
            setShowModal(false);
            reopenOffcanvas();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors;
            } else {
                console.error(`Error updating`, error);
            }
        }
    };

    const fetchIndustries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/industries`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            setIndustries(response.data.industry);
        } catch (error) {
            console.error('Error fetching industries:', error);
        }
    };

    // Add these above return
    const temporarilyHideOffcanvas = () => {
        console.log("👉 temporarilyHideOffcanvas called");
        setIsTemporarilyHidden(true);
    };

    const reopenOffcanvas = () => {
        console.log("👉 reopenOffcanvas called");
        setIsTemporarilyHidden(false);
    };

    const handleOffcanvasClose = () => {
        console.log("❌ handleOffcanvasClose called (fully closing)");
        setOrganisationDetails(null);
        setActiveTab('contactList');
        didFetchRef.current = false;
        handleClose();
    };


    const getOrgTypeVariant = (type) => {
        switch (type) {
            case 'end customer': return 'success';
            case 'partner': return 'primary';
            default: return 'secondary';
        }
    };


    return (
        <>
            <Offcanvas
                show={showOffcanvas}
                onHide={handleOffcanvasClose}
                placement="end"
                style={{ width: '950px' }}
                enforceFocus={false}
                className={`organisation-offcanvas-erp ${isTemporarilyHidden ? "offcanvas-hidden" : ""}`}
                backdrop={!isTemporarilyHidden}
            >
                {console.log("🎯 Offcanvas visible:", showOffcanvas && !isTemporarilyHidden)}
                {/* Header - ERP Style */}
                <Offcanvas.Header className="border-bottom bg-white py-3">
                    <div className="d-flex align-items-center w-100">
                        <div className="d-flex align-items-center flex-grow-1">
                            <div className="bg-primary rounded p-2 me-3">
                                <BsBuilding className="text-white" size={24} />
                            </div>
                            <div>
                                <Offcanvas.Title className="mb-0">
                                    <h4 className="fw-bold text-dark mb-1">{organisationDetails?.name || 'Organisation'}</h4>
                                </Offcanvas.Title>
                                <div className="d-flex align-items-center gap-2">
                                    <Badge
                                        bg={getOrgTypeVariant(organisationDetails?.org_type)}
                                        className="fs-12"
                                    >
                                        {organisationDetails?.org_type || ''}
                                    </Badge>
                                    <span className="text-muted fs-13">
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            {/* <Button
                                variant="outline-primary"
                                size="sm"
                                className="d-flex align-items-center gap-2"
                                onClick={() => {
                                    setSelectedOrganisation(organisationDetails);
                                    setShowModal(true);
                                }}
                            > */}
                            <Button
                                variant="outline-primary"
                                size="sm"
                                className="d-flex align-items-center gap-2"
                                onClick={() => {
                                    // Hide the offcanvas temporarily
                                    temporarilyHideOffcanvas();

                                    // Then open the edit modal
                                    setTimeout(() => {
                                        setSelectedOrganisation(organisationDetails);
                                        setShowModal(true);
                                    }, 300); // small delay to ensure smooth UI transition
                                }}
                            >

                                <BiPencil size={16} />
                                Edit
                            </Button>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                className="d-flex align-items-center gap-2"
                                onClick={handleOffcanvasClose}
                            >
                                <BsX size={18} />
                                Close
                            </Button>
                        </div>
                    </div>
                </Offcanvas.Header>

                <Offcanvas.Body className="p-0 bg-light">
                    {organisationDetails ? (
                        <div className="organisation-details-erp">
                            {/* Quick Stats Bar */}
                            <div className="bg-white border-bottom">
                                <div className="px-4 py-3">
                                    <Row className="g-3">
                                        <Col md={3}>
                                            <div className="d-flex align-items-center">
                                                <div className="bg-light rounded p-2 me-3">
                                                    <FaIndustry className="text-primary" size={18} />
                                                </div>
                                                <div>
                                                    <div className="text-muted fs-12 fw-semibold">INDUSTRY</div>
                                                    <div className="fw-semibold text-dark">{organisationDetails?.industry?.name || 'N/A'}</div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="d-flex align-items-center">
                                                <div className="bg-light rounded p-2 me-3">
                                                    <BsPeople className="text-info" size={18} />
                                                </div>
                                                <div>
                                                    <div className="text-muted fs-12 fw-semibold">EMPLOYEES</div>
                                                    <div className="fw-semibold text-dark">{organisationDetails?.employee_size || 'N/A'}</div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="d-flex align-items-center">
                                                <div className="bg-light rounded p-2 me-3">
                                                    <BsGeoAlt className="text-warning" size={18} />
                                                </div>
                                                <div>
                                                    <div className="text-muted fs-12 fw-semibold">COUNTRY</div>
                                                    <div className="fw-semibold text-dark">{organisationDetails?.country?.name || 'N/A'}</div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="d-flex align-items-center">
                                                <div className="bg-light rounded p-2 me-3">
                                                    <FaIdCard className="text-success" size={16} />
                                                </div>
                                                <div>
                                                    <div className="text-muted fs-12 fw-semibold">CURRENCY</div>
                                                    <div className="fw-semibold text-dark">{organisationDetails?.currency || 'N/A'}</div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>

                            {/* Main Content Area */}
                            <div className="p-4">
                                {/* Tabs Navigation - ERP Style */}
                                <div className="mb-4">
                                    <div className="nav-tabs-erp border-bottom">
                                        <WithContactPermission>
                                            <button
                                                className={`nav-tab-erp ${activeTab === 'contactList' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('contactList')}
                                                type="button"
                                            >
                                                <BsPeople className="me-2" size={16} />
                                                Contacts
                                                {organisationDetails?.contacts?.length > 0 && (
                                                    <Badge bg="light" text="dark" className="ms-2 fs-11">
                                                        {organisationDetails.contacts.length}
                                                    </Badge>
                                                )}
                                            </button>
                                        </WithContactPermission>
                                        <button
                                            className={`nav-tab-erp ${activeTab === 'organisationDetails' ? 'active' : ''}`}
                                            onClick={() => setActiveTab('organisationDetails')}
                                            type="button"
                                        >
                                            <MdBusiness className="me-2" size={16} />
                                            Organisation Details
                                        </button>
                                        {/* <button
                                            className={`nav-tab-erp ${activeTab === 'activities' ? 'active' : ''}`}
                                            onClick={() => setActiveTab('activities')}
                                            type="button"
                                        >
                                            <MdWork className="me-2" size={16} />
                                            Activities
                                        </button> */}
                                    </div>
                                </div>

                                {/* Tab Content */}
                                <div className="tab-content-erp">
                                    {/* Contact List Tab */}
                                    {activeTab === "contactList" && (
                                        <div className="tab-pane-erp active">
                                            <div className="bg-white rounded border">
                                                <div className="p-3 border-bottom bg-light">
                                                    <h6 className="fw-semibold text-dark mb-0">Contact Management</h6>
                                                </div>
                                                <div className="p-3">
                                                    <SelectedContact
                                                        organisationId={organisationDetails?.id}
                                                        entityType="org"
                                                        fetchOrganisationData={fetchOrganisationDetails}
                                                        organisationData={organisationDetails}
                                                        setOrganisationDetails={setOrganisationDetails}
                                                        // onCloseOffcanvas={handleOffcanvasClose}
                                                        //  onReopenOffcanvas={handleReopenOffcanvas}
                                                         onCloseOffcanvas={temporarilyHideOffcanvas}
                                                         onReopenOffcanvas={() => {
                                                             setShowContactModal(false);
                                                             setIsTemporarilyHidden(false);
                                                             // No need to set showOffcanvas here as it's already true in parent
                                                         }}
                                                        showContactModal={showContactModal}
                                                        setShowContactModal={setShowContactModal}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* Organisation Details Tab */}
                                    {activeTab === "organisationDetails" && (
                                        <div className="tab-pane-erp active">
                                            <div className="bg-white rounded border">
                                                <div className="p-3 border-bottom bg-light">
                                                    <h6 className="fw-semibold text-dark mb-0">Organisation Information</h6>
                                                    <small className="text-muted">Complete organisation details and settings</small>
                                                </div>
                                                <div className="p-3">
                                                    <OrganisationView
                                                        data={organisationDetails}
                                                        type="org"
                                                        organisationId={organisationId}
                                                        setOrganisationDetails={setOrganisationDetails}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* Activities Tab */}
                                    {activeTab === "activities" && (
                                        <div className="tab-pane-erp active">
                                            <div className="bg-white rounded border">
                                                <div className="p-3 border-bottom bg-light">
                                                    <h6 className="fw-semibold text-dark mb-0">Recent Activities</h6>
                                                    <small className="text-muted">Organisation activities and timeline</small>
                                                </div>
                                                <div className="p-4 text-center">
                                                    <div className="text-muted">
                                                        <MdWork size={48} className="mb-3 opacity-25" />
                                                        <div>No activities recorded</div>
                                                        <small>Activities will appear here when available</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>


                            </div>
                        </div>
                    ) : (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
                            <div className="text-center">

                            </div>
                        </div>
                    )}
                </Offcanvas.Body>
            </Offcanvas>

            {/* Edit Organisation Modal */}
            {showModal && (
                <OrganisationModal
                    showModal={showModal}
                    handleClose={() => {
                        setShowModal(false);
                        reopenOffcanvas();
                    }}
                    orgData={selectedOrganisation}
                    editOrg={editOrganisation}
                    fetchIndustries={fetchIndustries}
                    orgId={organisationId}
                    orgs={orgs}
                    industries={industries}
                />
            )}
        </>
    );
};

export default OrganisationDetails;

// import { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import OrganisationView from './OrganisationView';
// import SelectedContact from '../../contact/SelectedContact';
// import withPermission from '../../../utils/withPermission';
// import { Offcanvas, Button, Badge, Row, Col } from 'react-bootstrap';
// import { BsBuilding, BsPeople, BsGeoAlt, BsX } from "react-icons/bs";
// import { FaIndustry, FaIdCard } from "react-icons/fa";
// import OrganisationModal from './OrganisationModal';

// const OrganisationDetails = ({ showOffcanvas: initialShowOffcanvas, handleClose, organisationId }) => {

//     const [organisationDetails, setOrganisationDetails] = useState(null);
//     const [activeTab, setActiveTab] = useState("contactList");
//     const didFetchRef = useRef(false);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedOrganisation, setSelectedOrganisation] = useState(null);
//     const [industries, setIndustries] = useState([]);
//     const WithContactPermission = withPermission(({ children }) => children, ["contact-list"]);
//     const [showContactModal, setShowContactModal] = useState(false);

//     // ✅ NEW FIX
//     const [showOffcanvas, setShowOffcanvas] = useState(initialShowOffcanvas);
//     const [isTemporarilyHidden, setIsTemporarilyHidden] = useState(false);

//     useEffect(() => {
//         setShowOffcanvas(initialShowOffcanvas);
//     }, [initialShowOffcanvas]);

//     useEffect(() => {
//         if (showOffcanvas && organisationId && !didFetchRef.current) {
//             fetchOrganisationDetails();
//             didFetchRef.current = true;
//         }
//     }, [organisationId, showOffcanvas]);

//     const fetchOrganisationDetails = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem("user-origin");
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/organisation/${organisationId}`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     "Tenant-Origin": origin,
//                 },
//                 skipLoader: true,
//             });

//             setOrganisationDetails(response.data.data);
//         } catch (error) {
//             console.error("Error fetching organisation details:", error);
//         }
//     };

//     // ✅ Hide the offcanvas visually but DO NOT unmount it
//     const temporarilyHideOffcanvas = () => {
//         setIsTemporarilyHidden(true);
//     };

//     // ✅ Reopen the offcanvas visually
//     const reopenOffcanvas = () => {
//         setIsTemporarilyHidden(false);
//     };

//     // ✅ Fully close offcanvas (when click X)
//     const handleOffcanvasClose = () => {
//         setOrganisationDetails(null);
//         didFetchRef.current = false;
//         handleClose();
//     };

//     const getOrgTypeVariant = (type) => {
//         switch (type) {
//             case "end customer": return "success";
//             case "partner": return "primary";
//             default: return "secondary";
//         }
//     };

//     return (
//         <>
//             <Offcanvas
//     show={showOffcanvas}
//     onHide={() => {}}    // ✅ STOP bootstrap from auto closing
//     backdrop={false}      // ✅ CLICK OUTSIDE WON'T CLOSE
//     scroll={true}
//     placement="end"
//     className={`organisation-offcanvas-erp ${isTemporarilyHidden ? "offcanvas-hidden" : ""}`}
//     style={{ width: "950px" }}
// >

//                 {/* Header */}
//                 <Offcanvas.Header className="border-bottom bg-white py-3">
//                     <div className="d-flex align-items-center w-100">

//                         <div className="d-flex align-items-center flex-grow-1">
//                             <div className="bg-primary rounded p-2 me-3">
//                                 <BsBuilding className="text-white" size={24} />
//                             </div>

//                             <div>
//                                 <h4 className="fw-bold mb-1">{organisationDetails?.name || "Organisation"}</h4>
//                                 <Badge bg={getOrgTypeVariant(organisationDetails?.org_type)}>
//                                     {organisationDetails?.org_type}
//                                 </Badge>
//                             </div>
//                         </div>

//                         <Button variant="outline-secondary" size="sm" onClick={handleOffcanvasClose}>
//                             <BsX size={18} /> Close
//                         </Button>
//                     </div>
//                 </Offcanvas.Header>

//                 <Offcanvas.Body className="p-0 bg-light">
//                     {organisationDetails && (
//                         <div className="p-4">
//                             {/* TABS */}
//                             <div className="mb-3 border-bottom">
//                                 <WithContactPermission>
//                                     <button
//                                         className={`nav-tab-erp ${activeTab === 'contactList' ? 'active' : ''}`}
//                                         onClick={() => setActiveTab('contactList')}
//                                     >
//                                         <BsPeople className="me-2" />
//                                         Contacts
//                                     </button>
//                                 </WithContactPermission>

//                                 <button
//                                     className={`nav-tab-erp ${activeTab === 'organisationDetails' ? 'active' : ''}`}
//                                     onClick={() => setActiveTab('organisationDetails')}
//                                 >
//                                     Organisation Details
//                                 </button>
//                             </div>

//                             {/* TAB CONTENT */}
//                             {activeTab === "contactList" && (
//                                 <SelectedContact
//                                     organisationId={organisationDetails?.id}
//                                     entityType="org"
//                                     fetchOrganisationData={fetchOrganisationDetails}
//                                     organisationData={organisationDetails}
//                                     setOrganisationDetails={setOrganisationDetails}
                                  
//                                     // ✅ NEW FIXED HANDLERS
//                                     onCloseOffcanvas={temporarilyHideOffcanvas}
//                                     onReopenOffcanvas={reopenOffcanvas}
//                                 />
//                             )}

//                             {activeTab === "organisationDetails" && (
//                                 <OrganisationView data={organisationDetails} />
//                             )}
//                         </div>
//                     )}
//                 </Offcanvas.Body>
//             </Offcanvas>

//             {showModal && (
//                 <OrganisationModal
//                     showModal={showModal}
//                     handleClose={() => setShowModal(false)}
//                     orgData={selectedOrganisation}
//                     editOrg={() => {}}
//                     industries={industries}
//                 />
//             )}
//         </>
//     );
// };

// export default OrganisationDetails;
